import React from "react";
import styled from "styled-components";
import FullButton from "../Buttons/FullButton";
import HeaderImage from "../../assets/img/header-img.png";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

export default function Header() {
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
          <h1 className="extraBold font60">Professional Auctioneering. Trusted Results.</h1>

          {/* <HeaderP className="font13 semiBold">
            Sare Auctioneers is a licensed Class B auctioneering firm providing professional
            auctioneering, asset realization, repossession, debt collection, court process
            serving, and related services across Kenya and East Africa.
          </HeaderP> */}

          <HeaderP className="font13 semiBold">
            Sare Auctioneers is a licensed Class B auctioneering firm licensed under
            Cap. 526 (Auctioneers Act) of the Laws of Kenya. The firm provides
            professional auctioneering, asset realization, repossession, debt collection,
            court process serving, and related services across Kenya and East Africa,
            regulated and overseen by the Auctioneers
            Licensing Board.
          </HeaderP>

        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img className="radius8" src={HeaderImage} alt="office" style={{ zIndex: 9 }} />
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}

const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  color: #5d191a;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;

const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  color: #3b1718;

  @media (max-width: 960px) {
    flex-direction: column;
    min-height: auto;
    padding-top: 60px;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;

  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;          
    padding-bottom: 12px;       
  }
`;

const Img = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  object-fit: cover;

  @media (max-width: 960px) {
    max-height: 60vh;      
    width: auto;
    object-fit: contain;   
  }

  @media (max-width: 560px) {
    max-height: 55vh;
    width: 80%;
  }
`;

